export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8662.584a5a8c.jpg";